<template>
  <div>
    <div class="banner">
      <img class="img-100" src="@/assets/img/zhaoshang/banner.png" alt srcset />
    </div>

    <div class="card">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <el-card class="box-card">
              <div class="card-item">
                <img class="img" src="@/assets/img/zhaoshang/icon1.png" alt srcset />

                <div class="title">什么是旗舰店</div>
                <div class="con">当地最大综合性医院及当地最大的儿呼吸专科医院的柜机</div>

                <div class="btn" @click="apply">我要报名</div>
              </div>
            </el-card>
          </div>

          <div class="col-md-6">
            <el-card class="box-card">
              <div class="card-item">
                <img class="img" src="@/assets/img/zhaoshang/icon2.png" alt srcset />

                <div class="title">什么是标准店</div>
                <div class="con">区县级妇幼、儿童等专科医院的柜机的柜机</div>

                <div class="btn" @click="apply">我要报名</div>
              </div>
            </el-card>
          </div>

          <div
            class="introduce"
          >由公司进行投资，在目标医院开设柜机，面向区域内呼吸疾病儿童患者提供雾化器及耗材租售服务。加盟商仅需缴纳加盟费完成柜机入院即可等待收取收益。临床与患者运营全部由公司统一经营，每月按约定比例进行销售额分配。</div>
        </div>
      </div>
    </div>

    <div class="new-moshi">
      <div class="container">
        <div class="row">
          <div class="moshi" >
            <div class="title">为什么要加入新零售模式</div>
            <div class="sub-title">解决入院难题 加盟商躺赚</div>
            <img class="img-100" src="@/assets/img/zhaoshang/guiji.png" alt srcset />
          </div>
        </div>
      </div>
    </div>

    <div class="distinction">
      <div class="container">
        <div class="row">
          <div class="sub-d">
            <div class="title">与传统医疗代理的区别</div>
            <img class="img-100" src="@/assets/img/zhaoshang/qubie.png" alt srcset />
          </div>
        </div>
      </div>
    </div>

    <div class="apply">
      <div class="container">
        <div class="row">
          <div class="ask-for">
            <div class="title">跑马圈地 就趁此时</div>

            <ul class="ask-list">
              <li class="name">基本要求</li>
              <li class="item">
                <img src="@/assets/img/zhaoshang/radio.png" alt srcset /> 认同未来移动医疗的愿景，热爱医疗行业
              </li>
              <li class="item">
                <img src="@/assets/img/zhaoshang/radio.png" alt srcset /> 有一定临床资源和长期经营的决心，配合公司运营团队开展临床公关业务
              </li>
              <li class="item">
                <img src="@/assets/img/zhaoshang/radio.png" alt srcset /> 拥有正规公司资质
              </li>
              <li class="item">
                <img src="@/assets/img/zhaoshang/radio.png" alt srcset /> 愿意接受未来移动医疗新零售合作模式，缴纳履约加盟费（前期可作为保证金）
              </li>
              <li class="item">
                <img src="@/assets/img/zhaoshang/radio.png" alt srcset /> 所在城市临床经验较丰富的企业与个人优先
              </li>
            </ul>
            <div class="btn" @click="apply">我要报名</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: ""
    };
  },
  beforeMount() {
    const that = this;
    var w = document.documentElement.clientWidth || document.body.clientWidth;
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    if (w > 992) {
      that.height = h + "px";
    } else {
      that.height = h / 2 + "px";
    }
    window.onresize = () => {
      var w = document.documentElement.clientWidth || document.body.clientWidth;
      var h =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (w > 992) {
        that.height = h + "px";
      } else {
        that.height = h / 2 + "px";
      }
    };
  },
  methods: {
    apply() {
      window.open("http://sanic.web.yirdoc.com.cn/weilai/inifo.html", "_blank");
    }
  }
};
</script>


<style lang="scss" scoped>
.card {
  padding: 80px 0 20px 0;

  .card-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px;

    .img {
      width: 60px;
      height: 60px;
    }

    .title {
      font-size: 20px;
      font-weight: 600;
      padding: 10px 0;
    }

    .con {
      text-align: center;
      font-size: 16px;
      color: #8d8d8d;
    }

    .btn {
      width: 160px;
      height: 50px;
      background: rgba(13, 156, 145, 1);
      border-radius: 10px;
      font-size: 16px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    }
  }
}

.introduce {
  padding: 20px 50px;
  color: #7d7d7d;
}

.new-moshi {
  background-color: transparent;
  background-image: url("../../assets/img/zhaoshang/bg.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 60px 0;

  .moshi {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .title {
      font-size: 48px;
      font-weight: 400;
    }

    .sub-title {
      font-size: 26px;
      margin-bottom: 30px;
    }
  }
}

.distinction {
  padding: 60px 0;

  .sub-d {
    .title {
      font-size: 48px;
      font-weight: 400;
      padding: 30px 0;
      text-align: center;
    }
  }
}

.apply {
  background-color: transparent;
  background-image: url("../../assets/img/zhaoshang/bg2.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 80px;

  .ask-for {
    width: 100%;
    color: #fff;
    .title {
      text-align: center;
      font-size: 48px;
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 150px;
      height: 50px;
      background: rgba(13, 156, 145, 1);
      border-radius: 10px;
      color: #fff;
    }

    .ask-list {
      padding: 100px 0 80px 0;

      .name {
        font-size: 26px;
        margin-bottom: 10px;
      }

      .item {
        font-size: 16px;
        margin-bottom: 4px;
        display: flex;
        align-items: center;

        img {
          width: 10px;
          margin-right: 10px;
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .card {
    padding-top: 20px;
  }

  .box-card {
    margin: 0 10px;
    margin-bottom: 10px;
  }

  .new-moshi {
    .moshi {
      padding: 0 10px;
      .title {
        font-size: 18px;
      }

      .sub-title {
        font-size: 16px;
        margin-bottom: 20px;
      }
    }
  }

  .distinction {
    padding: 0;
    .sub-d {
      .title {
        font-size: 18px;
        padding: 10px 0;
      }
    }
  }

  .apply {
    padding: 30px;

    .ask-for {
      .title {
        font-size: 20px;
      }

      .ask-list {
        padding: 10px 0 10px 0;

        .name {
          font-size: 18px;
          margin-bottom: 10px;
        }

        .item {
          font-size: 14px;
          margin-bottom: 4px;
          display: flex;
          align-items: center;

          img {
            width: 10px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>

<style >
.box-card {
  margin: 0 50px;
  margin-bottom: 10px;
}
</style>